import { render, staticRenderFns } from "./TransferIssueVoucherEditView.vue?vue&type=template&id=32b1465a"
import script from "./TransferIssueVoucherEditView.vue?vue&type=script&lang=js"
export * from "./TransferIssueVoucherEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports